export const formatIanaTimezone = (timezone: string) => {
  // NOTE (Kurt, 2025-03-03): We format the IANA timezone name to be more readable by
  // replacing underscores with spaces and adding spaces around slashes.
  return timezone.replace(/_/g, " ").replace(/\//g, " / ");
};
